export const columnStickyPosition = "16px";
const cardPadding = "24px";

// including paddings of <Card> and margins to the edges of the screen
export const columnHeight = `calc(100vh - ${columnStickyPosition} * 2 - ${cardPadding} * 2)`;
export const minColumnHeight = "500px";


